import { PowerFunnelGatedFeatures } from './constants';

const GATED_COLLEGE_FILTERS = ['division', 'conference', 'collegesMore', 'utrFit'];

export const getGatedFeatureForFilter = (filterName) => {
    switch (filterName) {
        case 'division':
            return PowerFunnelGatedFeatures.COLLEGE_CORNER_DIVISIONS_FILTER;
        case 'conference':
            return PowerFunnelGatedFeatures.COLLEGE_CORNER_CONFERENCES_FILTER;
        case 'nationality':
            return PowerFunnelGatedFeatures.COLLEGE_CORNER_NATIONALITIES_FILTER;
        case 'snapshotDate':
            return PowerFunnelGatedFeatures.COLLEGE_CORNER_SNAPSHOT_DATE_FILTER;
        case 'utrFit':
            return PowerFunnelGatedFeatures.COLLEGE_CORNER_FIT_TOOL_FILTER;
        case 'collegesMore':
            return PowerFunnelGatedFeatures.COLLEGE_CORNER_MORE_FILTER;
        case 'colleges':
            return PowerFunnelGatedFeatures.PLAYER_COLLEGES_FILTER;
        case 'playersMoreMobile':
            return PowerFunnelGatedFeatures.PLAYER_MORE_MOBILE_FILTER;
        default:
            return null;
    }
};

export const shouldGateCollegeFilter = ({ filterName, isPowerUser, isProCollegeClubOrganizer }) => {
    if (!GATED_COLLEGE_FILTERS.includes(filterName)) return false;
    if (filterName === 'utrFit') {
        return !isPowerUser && !isProCollegeClubOrganizer;
    }
    return !isPowerUser;
};
